import { render } from "./account-top-business.component.vue?vue&type=template&id=0809b7f8&ts=true"
import script from "./account-top-business.component.vue?vue&type=script&lang=ts"
export * from "./account-top-business.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__